<lib-icon
  icon="help_outline"
  class="app-hint-icon"
  color="accent"
  [inline]="true"
  [matTooltip]="text"
></lib-icon>
